import { render, staticRenderFns } from "./ViewPartner.vue?vue&type=template&id=a919cd02&"
import script from "./ViewPartner.vue?vue&type=script&lang=js&"
export * from "./ViewPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports